import { DestroyRef, Directive, ElementRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BrandingService } from '@ieCore/services/branding.service';

// Overrides the guest panel's default SCSS background when the tenant has a
// custom login image; the gradient keeps the white slogan text readable on
// arbitrary photos. Without a custom image the element is left untouched so
// the SCSS default applies.
@Directive({ selector: '[ieGuestBackground]', standalone: true })
export class GuestBackgroundDirective implements OnInit {
  constructor(
    private el: ElementRef<HTMLElement>,
    private brandingService: BrandingService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.brandingService.loginBackground$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((url) => {
        if (url) {
          this.el.nativeElement.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), url("${url}")`;
        }
      });
  }
}
